import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Jak przypominać innym o terminie zwrotu naszych książek\ndescription: Wystarczy ustawić przypomnienie na egzemplarzu, który należał do nas.\n---\n\nBibliodesk umożliwia ustawianie przypomnień dla książek od nas pożyczonych.\n\n___\n\nPrzypomnienie jest wiadomością mejlową, która wysyłana jest automatycznie przez system do posiadacza danego egzemplarza.\n\n## Korzystanie z przypomnień\n\nNa półce książek pożyczonych dostępna jest kolumna __Przypomnień__.\n\n![Przypomnienia](/imgs/docs/bibliodesk/copies/bibliodesk-przypomnienia.png)\n\nNaciśnięcie przycisku rozwija menu z którego należy wybrać czas za jaki zostanie wysłane powiadomienie.\n\nIstnieje również możliwość wysłania powiadomienia od razu. W tym celu należy kliknąć __Przypomnij Teraz__.\n\n![Przypomnienia](/imgs/docs/bibliodesk/copies/bibliodesk-przypomnienia-ustaw.png)\n\nPo ustawieniu Przypomnienia, można podejrzeć datę zaplanowanego wysłania oraz je usunąć (użytkownik, która posiada naszą książkę nie zostanie wtedy powiadomiony).\n\n![Przypomnienia](/imgs/docs/bibliodesk/copies/bibliodesk-przypomnienia-ustawione.png)\n\nPowiadomienie wysłane przez system wygląda nas†ępująco:\n\n![Przypomnienia](/imgs/docs/bibliodesk/copies/bibliodesk-przypomnienia-email.png)\n\n\n";
const filepath = "/docs/bibliodesk-ustawianie-przypomnien-zwrotu-ksiazek.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
